import * as React from 'react';
import { IconPlus16 } from '@cian/ui-kit';
import * as styles from './AddButton.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function AddButton(_ref) {
  var text = _ref.text,
    showIcon = _ref.showIcon,
    onClick = _ref.onClick;
  return /*#__PURE__*/_jsxs("button", {
    className: styles['button'],
    onClick: onClick,
    children: [showIcon && /*#__PURE__*/_jsx("span", {
      className: styles['icon'],
      children: /*#__PURE__*/_jsx(IconPlus16, {})
    }), /*#__PURE__*/_jsx("span", {
      children: text
    })]
  });
}